export const colors = {
  blue: '#3eb0ef',
  green: '#a4d037',
  purple: '#ad26b4',
  yellow: '#fecd35',
  red: '#f05230',
  darkgrey: '#15171A',
  midgrey: '#738a94',
  lightgrey: '#1F364D',
  whitegrey: '#e5eff5',
  pink: '#fa3a57',
  brown: '#a3821a',
  // darkmode: color(var(--darkgrey) l(+2%)),
  //darkmode: '#12181b',
 // darkmode: '#131417',
 darkmode: '#0E2439',
  //textnormal: '#c7c9d3',
  textnormal: '#a2b8cd',
};
